module.exports = __webpack_public_path__ + "media/images/about/b3-7dde5ce3e8ab5c0859acdfcc7f9ca758.png";